import { Controller } from 'stimulus'

// Cells sort on their data-sort-value, so "27:10" or "57 km" order by the raw number.
// With data-sort-groups, each <tbody> moves as one block, keyed on its first row.
export default class extends Controller {

  sort(event) {
    const header    = event.currentTarget.closest('th')
    const index     = [...header.parentNode.children].indexOf(header)
    const numeric   = header.dataset.sortType !== 'text'
    const direction = this.nextDirection(header, numeric)
    const sign      = direction === 'ascending' ? 1 : -1
    const value     = item => this.keyRow(item).cells[index].dataset.sortValue
    const collator  = new Intl.Collator(document.documentElement.lang || undefined, { sensitivity: 'base', numeric: true })

    header.parentNode.querySelectorAll('th[aria-sort]').forEach(th => th.removeAttribute('aria-sort'))
    header.setAttribute('aria-sort', direction)

    const items = this.items.sort((a, b) =>
      sign * (numeric ? parseFloat(value(a)) - parseFloat(value(b)) : collator.compare(value(a), value(b)))
    )
    this.grouped ? this.element.append(...items) : this.body.append(...items)
  }

  get grouped() {
    return this.element.dataset.sortGroups === 'true'
  }

  get items() {
    return this.grouped ? [...this.element.tBodies] : [...this.body.rows]
  }

  keyRow(item) {
    return this.grouped ? item.rows[0] : item
  }

  get body() {
    return this.element.tBodies[0]
  }

  // Figures open on the largest, names on A.
  nextDirection(header, numeric) {
    const current = header.getAttribute('aria-sort')
    if (current) return current === 'descending' ? 'ascending' : 'descending'

    return numeric ? 'descending' : 'ascending'
  }
}
